import { createContext } from 'react';
var TableContext =
/*#__PURE__*/
createContext({
  dispatchRowChangedEvent: function dispatchRowChangedEvent() {
    return void 0;
  },
  focusedRowIndexRef: {
    current: -1
  },
  listenKeyEvents: false,
  setBodyNode: function setBodyNode() {
    return void 0;
  }
});
export { TableContext };